module.exports = "/img/_/_/_/assets/images/avatar/full_left/male//rogue.jpg?ea8d050523f0b014aea739d4d82a5668";